




















import PluginComponent from '@/components/plugins/PluginComponent';
import  { EVENTS } from '@/services/EventBus';
import { Layer } from 'ol/layer';
import Component from 'vue-class-component';

@Component
export default class SwipePlugin extends PluginComponent {
    static ID='SwipePlugin';

    apiKey = '';

    viewer!:any;

    layer:any=null;

    selectedLayer:any=null;

    swipe: any = null;

    cutLeft = false;

    enabled = false;

    showLayerChoice = false;

    prerender(event:any) {
      if (this.enabled) {
        this.getMapService().preRenderSwipe(event, this.swipe?.value, this.cutLeft);
      }
    }


    postrender(event: any) {
      this.getMapService().postRenderSwipe(
        event,
        this.swipe?.value,
        this.cutLeft,

      );
    }
    activeSwipe(){
      this.layer.un('prerender', this.prerender);
      this.layer.un('postrender', this.postrender);
      this.layer.on('prerender', this.prerender);
      this.layer.on('postrender', this.postrender);
    }
    autocompleteSelect(parameter:any) {
      console.log(parameter);
      this.restoreLayer();
      this.layer=this.contextService.getCurrentContext().getLayerByUid(this.selectedLayer)?.getOlLayer();
      this.activeSwipe();
    }

    mounted() {
      this.showLayerChoice=this.plugin.getParameterValue('showLayerChoice')!=null?this.plugin.getParameterValue('showLayerChoice'):false;
      //wait for layer to be loaded => todo use event instead of delay
      setTimeout(()=>{
        this.swipe = document.getElementById('swipe');
        this.cutLeft = this.plugin.getParameterValue('cutLeft') === true;
        this.layer = this.getLayer('layer');
        if (this.layer) {
          this.selectedLayer=this.layer;
          this.activeSwipe();
          this.enabled = true;
        } else {
          this.enabled = false;
        }
        this.getEventBus().$emit(EVENTS.SWIPE_ENABLED, this.enabled);
      },1000);
     
    }

   
    restoreLayer(){
      if (this.layer) {
        this.layer.un('prerender', this.prerender);
        this.layer.un('postrender', this.postrender);
        this.layer.changed();
      }
    }
    beforeDestroy() {
      this.restoreLayer();
    }    

    toggleActive() {
      this.enabled = !this.enabled;
      this.getEventBus().$emit(EVENTS.SWIPE_ENABLED, this.enabled);
      this.layer.changed();
    }

    autocompleteOptions():any {
        return this.contextService.getCurrentContext().getOrderedLayerList().map((v) => ({
          text: v.title,
          value: v.uid,
        }));

    }


    getLayer(layerPluginField:string): Layer | undefined {
      let layer;
      const layerUid = this.plugin.getParameterValue(layerPluginField);
      if (layerUid) {
        const layerConfig = this.contextService.getCurrentContext().getLayerByUid(layerUid);
        if (layerConfig) {
          layer = layerConfig.getOlLayer();
        }
      }
      return layer;
    }
}
